import { ChangeDetectionStrategy, Component, HostBinding, Inject, OnInit, inject } from '@angular/core';

import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { WINDOW } from '@campus/browser';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'kabas-legals-page-container',
  templateUrl: './legals-page-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalsPageContainerComponent implements OnInit {
  public slug$: Observable<string>;
  private title = inject(Title);

  constructor(
    private route: ActivatedRoute,
    @Inject(WINDOW)
    private window: Window
  ) {}

  ngOnInit() {
    this.slug$ = this.getSlug();
  }

  getSlug(): Observable<string> {
    return this.route.params.pipe(
      map((params) => params.slug),
      tap((slug) => {
        this.title.setTitle(`Kabas - ${slug}`);
      })
    );
  }
}
